var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('vue-headful',{attrs:{"title":_vm.$t('title_library'),"description":"title"}}),_c('TabSelector',{staticClass:"mt-6",staticStyle:{"margin-left":"10px"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }